class ProductEngraving extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-engraving-input]");
    this.count = this.querySelector("[data-engraving-count]");
    this.limitMessage = this.querySelector("[data-engraving-limit-message]");

    if (!this.input || !this.count || !this.limitMessage) return;

    this.form = this.input.form || this.input.closest("form");

    this.input.addEventListener("input", this.updateCharacterFeedback);
    this.form?.addEventListener("formdata", this.handleFormData);
    this.updateCharacterFeedback();
  }

  disconnectedCallback() {
    this.input?.removeEventListener("input", this.updateCharacterFeedback);
    this.form?.removeEventListener("formdata", this.handleFormData);
  }

  handleFormData = (event) => {
    const engraving = this.input?.value?.trim() || "";

    if (engraving) {
      event.formData.set("properties[Engraving]", engraving);
    } else {
      event.formData.delete("properties[Engraving]");
    }
  };

  updateCharacterFeedback = () => {
    const currentLength = this.input.value.length;
    const maximum = this.input.maxLength;
    const atLimit = currentLength >= maximum;

    this.count.textContent = `${currentLength} / ${maximum} characters`;
    this.limitMessage.textContent = atLimit
      ? `Maximum ${maximum} characters reached.`
      : "";
    this.limitMessage.classList.toggle("hidden", !atLimit);
  };
}

if (!customElements.get("product-engraving")) {
  customElements.define("product-engraving", ProductEngraving);
}
